import { Receipt, Transaction } from '@/types/payments';
import { addDays, subDays } from 'date-fns';

// Mock Receipts Data
export const generateMockReceipts = (): Receipt[] => {
  return [
    // TEST RECEIPT FOR PROMISE TO PAY (Phase 2)
    {
      id: 1,
      receiptNumber: 'RCP-2025-001',
      customerId: 1,
      customerName: 'ABC Company Ltd',
      customerAccountNumber: 'ACC-001',
      receiptDate: new Date('2025-01-15'),
      receivedAmount: 1250.00,
      allocatedAmount: 0,
      unappliedAmount: 1250.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BACS-12345',
      bankReference: 'REF-2025-001',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FS-001',
      importedAt: new Date('2025-01-15'),
      createdBy: 'system',
      createdAt: new Date('2025-01-15'),
      notes: 'Payment received via bank transfer - MATCHES PROMISE',
      hasPromise: true,
      promiseToPayId: 1,
    },
    {
      id: 101,
      receiptNumber: 'RCP-001',
      customerId: 101,
      customerName: 'Acme Corporation Ltd',
      customerAccountNumber: 'ACC-001',
      receiptDate: new Date(),
      receivedAmount: 5000.00,
      allocatedAmount: 0,
      unappliedAmount: 5000.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-12345',
      bankReference: 'REF-2025-002',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-001',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 102,
      receiptNumber: 'RCP-002',
      customerId: 102,
      customerName: 'Tech Solutions Inc',
      customerAccountNumber: 'ACC-002',
      receiptDate: new Date(),
      receivedAmount: 3200.00,
      allocatedAmount: 2000.00,
      unappliedAmount: 1200.00,
      currency: 'GBP',
      paymentMethod: 'credit_card',
      paymentReference: 'CC-67890',
      allocationStatus: 'partially_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-002',
      importedAt: new Date(),
      createdBy: 'system',
      createdAt: new Date(),
      hasPromise: false,
    },
    {
      id: 103,
      receiptNumber: 'RCP-003',
      customerId: 103,
      customerName: 'Global Retail Shop Inc',
      customerAccountNumber: 'ACC-003',
      receiptDate: subDays(new Date(), 1),
      receivedAmount: 8500.00,
      allocatedAmount: 8500.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-54321',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-003',
      importedAt: subDays(new Date(), 1),
      createdBy: 'system',
      createdAt: subDays(new Date(), 1),
      hasPromise: false,
    },
    {
      id: 104,
      receiptNumber: 'RCP-004',
      customerId: 104,
      customerName: 'Manufacturing Co Ltd',
      customerAccountNumber: 'ACC-004',
      receiptDate: subDays(new Date(), 2),
      receivedAmount: 12500.00,
      allocatedAmount: 0,
      unappliedAmount: 12500.00,
      currency: 'GBP',
      paymentMethod: 'direct_debit',
      paymentReference: 'DD-11111',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-004',
      importedAt: subDays(new Date(), 2),
      createdBy: 'system',
      createdAt: subDays(new Date(), 2),
      hasPromise: false,
    },
    {
      id: 105,
      receiptNumber: 'RCP-005',
      customerId: 105,
      customerName: 'Services Group PLC',
      customerAccountNumber: 'ACC-005',
      receiptDate: subDays(new Date(), 3),
      receivedAmount: 7800.00,
      allocatedAmount: 5000.00,
      unappliedAmount: 2800.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-99999',
      allocationStatus: 'partially_allocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-005',
      importedAt: subDays(new Date(), 3),
      createdBy: 'system',
      createdAt: subDays(new Date(), 3),
      hasPromise: true,
      promiseToPayId: 102,
    },
    {
      id: 106,
      receiptNumber: 'RCP-006',
      customerId: 106,
      customerName: 'Digital Media Ltd',
      customerAccountNumber: 'ACC-006',
      receiptDate: subDays(new Date(), 5),
      receivedAmount: 4500.00,
      allocatedAmount: 0,
      unappliedAmount: 4500.00,
      currency: 'GBP',
      paymentMethod: 'cheque',
      paymentReference: 'CHQ-12345',
      allocationStatus: 'unallocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-006',
      importedAt: subDays(new Date(), 5),
      createdBy: 'system',
      createdAt: subDays(new Date(), 5),
      hasPromise: false,
    },
    {
      id: 107,
      receiptNumber: 'RCP-007',
      customerId: 107,
      customerName: 'Construction Partners Ltd',
      customerAccountNumber: 'ACC-007',
      receiptDate: subDays(new Date(), 7),
      receivedAmount: 15000.00,
      allocatedAmount: 15000.00,
      unappliedAmount: 0,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-77777',
      allocationStatus: 'fully_allocated',
      reconciliationStatus: 'reconciled',
      financeSystemId: 'FIN-007',
      importedAt: subDays(new Date(), 7),
      createdBy: 'system',
      createdAt: subDays(new Date(), 7),
      hasPromise: false,
    },
    {
      id: 108,
      receiptNumber: 'RCP-008',
      customerId: 108,
      customerName: 'Healthcare Systems Inc',
      customerAccountNumber: 'ACC-008',
      receiptDate: subDays(new Date(), 10),
      receivedAmount: 9200.00,
      allocatedAmount: 3000.00,
      unappliedAmount: 6200.00,
      currency: 'GBP',
      paymentMethod: 'bank_transfer',
      paymentReference: 'BANK-88888',
      allocationStatus: 'partially_allocated',
      reconciliationStatus: 'pending',
      financeSystemId: 'FIN-008',
      importedAt: subDays(new Date(), 10),
      createdBy: 'system',
      createdAt: subDays(new Date(), 10),
      hasPromise: false,
    },
  ];
};

// Mock Transactions for Allocation
export const generateMockTransactions = (customerId: number): Transaction[] => {
  const transactions: Record<number, Transaction[]> = {
    // TEST TRANSACTIONS FOR PROMISE TO PAY (Phase 2)
    1: [
      {
        id: 1,
        transactionNumber: 'INV-2024-001',
        transactionType: 'invoice',
        customerId: 1,
        customerName: 'ABC Company Ltd',
        transactionDate: new Date('2024-12-01'),
        dueDate: new Date('2024-12-31'),
        originalAmount: 500.00,
        currentBalance: 500.00,
        currency: 'GBP',
        daysOverdue: 15,
        onDispute: false,
        promisedAmount: 500.00,
        isPromised: true,
      },
      {
        id: 2,
        transactionNumber: 'INV-2024-002',
        transactionType: 'invoice',
        customerId: 1,
        customerName: 'ABC Company Ltd',
        transactionDate: new Date('2024-12-05'),
        dueDate: new Date('2025-01-04'),
        originalAmount: 350.00,
        currentBalance: 350.00,
        currency: 'GBP',
        daysOverdue: 11,
        onDispute: false,
      },
      {
        id: 3,
        transactionNumber: 'INV-2024-003',
        transactionType: 'invoice',
        customerId: 1,
        customerName: 'ABC Company Ltd',
        transactionDate: new Date('2024-12-10'),
        dueDate: new Date('2025-01-09'),
        originalAmount: 450.00,
        currentBalance: 450.00,
        currency: 'GBP',
        daysOverdue: 6,
        onDispute: false,
        promisedAmount: 450.00,
        isPromised: true,
      },
      {
        id: 4,
        transactionNumber: 'INV-2024-004',
        transactionType: 'invoice',
        customerId: 1,
        customerName: 'ABC Company Ltd',
        transactionDate: new Date('2024-12-15'),
        dueDate: new Date('2025-01-14'),
        originalAmount: 275.00,
        currentBalance: 275.00,
        currency: 'GBP',
        daysOverdue: 1,
        onDispute: false,
      },
      {
        id: 5,
        transactionNumber: 'INV-2024-005',
        transactionType: 'invoice',
        customerId: 1,
        customerName: 'ABC Company Ltd',
        transactionDate: new Date('2024-12-20'),
        dueDate: new Date('2025-01-19'),
        originalAmount: 300.00,
        currentBalance: 300.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
        promisedAmount: 300.00,
        isPromised: true,
      },
      {
        id: 6,
        transactionNumber: 'INV-2024-006',
        transactionType: 'invoice',
        customerId: 1,
        customerName: 'ABC Company Ltd',
        transactionDate: new Date('2024-12-25'),
        dueDate: new Date('2025-01-24'),
        originalAmount: 425.00,
        currentBalance: 425.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
    ],
    101: [
      {
        id: 1001,
        transactionNumber: 'INV-1001',
        transactionType: 'invoice',
        customerId: 101,
        customerName: 'Acme Corporation Ltd',
        transactionDate: subDays(new Date(), 45),
        dueDate: subDays(new Date(), 15),
        originalAmount: 2000.00,
        currentBalance: 2000.00,
        currency: 'GBP',
        daysOverdue: 15,
        onDispute: false,
        promisedAmount: 2000.00,
        isPromised: true,
      },
      {
        id: 1002,
        transactionNumber: 'INV-1015',
        transactionType: 'invoice',
        customerId: 101,
        customerName: 'Acme Corporation Ltd',
        transactionDate: subDays(new Date(), 38),
        dueDate: subDays(new Date(), 8),
        originalAmount: 1500.00,
        currentBalance: 1500.00,
        currency: 'GBP',
        daysOverdue: 8,
        onDispute: false,
        promisedAmount: 1500.00,
        isPromised: true,
      },
      {
        id: 1003,
        transactionNumber: 'INV-1023',
        transactionType: 'invoice',
        customerId: 101,
        customerName: 'Acme Corporation Ltd',
        transactionDate: subDays(new Date(), 25),
        dueDate: addDays(new Date(), 5),
        originalAmount: 1500.00,
        currentBalance: 1500.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
        promisedAmount: 1500.00,
        isPromised: true,
      },
      {
        id: 1004,
        transactionNumber: 'INV-1030',
        transactionType: 'invoice',
        customerId: 101,
        customerName: 'Acme Corporation Ltd',
        transactionDate: subDays(new Date(), 20),
        dueDate: addDays(new Date(), 10),
        originalAmount: 3200.00,
        currentBalance: 3200.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
      {
        id: 1005,
        transactionNumber: 'INV-1035',
        transactionType: 'invoice',
        customerId: 101,
        customerName: 'Acme Corporation Ltd',
        transactionDate: subDays(new Date(), 15),
        dueDate: addDays(new Date(), 15),
        originalAmount: 1800.00,
        currentBalance: 1800.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
    ],
    102: [
      {
        id: 1006,
        transactionNumber: 'INV-2001',
        transactionType: 'invoice',
        customerId: 102,
        customerName: 'Tech Solutions Inc',
        transactionDate: subDays(new Date(), 50),
        dueDate: subDays(new Date(), 20),
        originalAmount: 2500.00,
        currentBalance: 1200.00,
        currency: 'GBP',
        daysOverdue: 20,
        onDispute: false,
      },
      {
        id: 1007,
        transactionNumber: 'INV-2010',
        transactionType: 'invoice',
        customerId: 102,
        customerName: 'Tech Solutions Inc',
        transactionDate: subDays(new Date(), 30),
        dueDate: new Date(),
        originalAmount: 1800.00,
        currentBalance: 1800.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
      {
        id: 1008,
        transactionNumber: 'INV-2015',
        transactionType: 'invoice',
        customerId: 102,
        customerName: 'Tech Solutions Inc',
        transactionDate: subDays(new Date(), 20),
        dueDate: addDays(new Date(), 10),
        originalAmount: 2200.00,
        currentBalance: 2200.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
    ],
    104: [
      {
        id: 1009,
        transactionNumber: 'INV-4001',
        transactionType: 'invoice',
        customerId: 104,
        customerName: 'Manufacturing Co Ltd',
        transactionDate: subDays(new Date(), 60),
        dueDate: subDays(new Date(), 30),
        originalAmount: 5000.00,
        currentBalance: 5000.00,
        currency: 'GBP',
        daysOverdue: 30,
        onDispute: false,
      },
      {
        id: 1010,
        transactionNumber: 'INV-4010',
        transactionType: 'invoice',
        customerId: 104,
        customerName: 'Manufacturing Co Ltd',
        transactionDate: subDays(new Date(), 45),
        dueDate: subDays(new Date(), 15),
        originalAmount: 4500.00,
        currentBalance: 4500.00,
        currency: 'GBP',
        daysOverdue: 15,
        onDispute: false,
      },
      {
        id: 1011,
        transactionNumber: 'INV-4020',
        transactionType: 'invoice',
        customerId: 104,
        customerName: 'Manufacturing Co Ltd',
        transactionDate: subDays(new Date(), 30),
        dueDate: new Date(),
        originalAmount: 3000.00,
        currentBalance: 3000.00,
        currency: 'GBP',
        daysOverdue: 0,
        onDispute: false,
      },
    ],
  };

  return transactions[customerId] || [];
};
